export default {
  "side-nav": () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/layouts/side-nav.vue")
}